module.exports = __webpack_public_path__ + "66d2393f289ef262b5889c6a10f59a4b.jpg";